module.exports = {"TXTMOB_Exclusive":{"id":"TXTMOB_Exclusive","defaultMessage":"Kun hos os","flags":["TRACK"],"track":"Exclusive"}}